import { PublicUnitsPage } from 'features/units/index.js';
import { Route } from 'react-router';
import { RoutePaths } from 'shared/routes.js';
import { asLazy } from 'shared/utils/lazy.utils.js';

const TermsAndConditionsPage = asLazy(
  import('../../pages/public/TermsAndConditionsPage/TermsAndConditionsPage.jsx'),
  'TermsAndConditionsPage',
);
const HomePage = asLazy(
  import('../../pages/public/HomePage/HomePage.jsx'),
  'HomePage',
);

export const usePublicRoutes = () => {
  return (
    <>
      <Route
        path={RoutePaths.RETIREMENT}
        element={<PublicUnitsPage type="Claim" />}
      />
      <Route path={RoutePaths.TERMS} element={<TermsAndConditionsPage />} />
      <Route path={RoutePaths.HOME} element={<HomePage />} />
    </>
  );
};
